import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import {NAME, LASTNAME} from '../settings';
class Sidepanel extends Component {
    constructor() {
        super();
        this.updateSync = this.updateSync.bind(this);
        this.state = {
            redirect: false,
            menu: {},
            fav: {},
          
        }
    }

    componentDidMount() {
        setInterval(this.updateSync, 60000);
        var context = this;
        // if (localStorage.getItem('menu') != null) {
        //     context.setState({
        //         menu: JSON.parse(localStorage.getItem('menu')),
        //         fav: JSON.parse(localStorage.getItem('fav'))
        //     })
        // }

        fetch(this.props.api + '/menu', { cache: "no-cache" }
        ).then(results => {
            return results.json();
        }).then(data => {
            context.setState({
                menu: data.menu,
                fav: data.fav
            });
            localStorage.setItem('menu', JSON.stringify(data.menu));
            localStorage.setItem('fav', JSON.stringify(data.fav));

        }).catch(error => {
            if (localStorage.getItem('menu') != null)
                this.setState({ menu: JSON.parse(localStorage.getItem('menu')), loading: false })

            if (localStorage.getItem('fav') != null)
                this.setState({ fav: JSON.parse(localStorage.getItem('fav')), loading: false })
        });
    }
    componentWillUnmount() {
        this.setState({ menu: {}, fav: {} })
    }
    setRedirect = (id, type) => {
        this.setState({
            redirect: true,
            id,
            type,
            route: '/' + type + '/' + id
        })
        // return this.renderRedirect();

    }
    renderRedirect = () => {
        if (this.state.redirect) {
            // console.log('/' + this.state.type + '/' + this.state.id);
            console.log("Redirecting...")
            return <Redirect to={'/' + this.state.type + '/' + this.state.id} />
        }
    }
    updateSync() {
        console.log("Actualizando Menu")
        var context = this;

        // if (localStorage.getItem('menu') != null) {
        //     context.setState({
        //         menu: JSON.parse(localStorage.getItem('menu')),
        //         fav: JSON.parse(localStorage.getItem('fav'))
        //     })
        // }


        fetch(context.props.api + '/menu', { cache: "no-cache" }
        ).then(results => {
            return results.json();
        }).then(data => {
            context.setState({
                menu: data.menu,
                fav: data.fav
            });
            localStorage.setItem('menu', JSON.stringify(data.menu));
            localStorage.setItem('fav', JSON.stringify(data.fav));

        }).catch(error => {
            if (localStorage.getItem('menu') != null)
                this.setState({ menu: JSON.parse(localStorage.getItem('menu')), loading: false })

            if (localStorage.getItem('fav') != null)
                this.setState({ fav: JSON.parse(localStorage.getItem('fav')), loading: false })

        });
    }
    render() {
        let data = this.state.menu;
        let sports = Object.keys(data);
        let countries;
        let leagues;
        if (sports.length > 0) {
            sports = sports.map(sportId => {
                if (data[sportId].countries) {
                    let dataCountries = data[sportId].countries;
                    countries = Object.keys(dataCountries);
                    countries = countries.map(countryId => {
                        if (dataCountries[countryId].leagues) {
                            let dataLeagues = dataCountries[countryId].leagues
                            leagues = Object.keys(dataLeagues);
                            leagues = leagues.map(leagueId => {
                                return <li key={leagueId}>
                                    <Link to={"/league/" + leagueId} className="text-truncate"><i className="fas fa-angle-double-right"></i> {dataLeagues[leagueId].name}</Link>
                                    {/* <a onClick={this.setRedirect.bind(this, dataLeagues[leagueId].id, 'league')} className="text-truncate" > <i className="fas fa-angle-double-right"></i> {dataLeagues[leagueId].name}</a> */}
                                </li>
                            })
                        } else {
                            return null;
                        }


                        return <li key={countryId}>
                            <Link to={"/group/" + dataCountries[countryId].id} >

                                <span data-toggle="collapse" aria-expanded="false"
                                    data-target={"#L" + sportId + "89" + countryId}
                                    className="dropdown-toggle d-block" >
                                    <i className={"ficon-inline f-" + countryId} />

                                    {dataCountries[countryId].name}

                                </span>


                            </Link>
                            {/* <Link to={"/group/" + dataCountries[countryId].id} data-toggle="collapse" aria-expanded="false" className="dropdown-toggle">
                                    <i className={"ficon-inline f-" + countryId} />
                                    {dataCountries[countryId].name}
                                </Link> */}
                            {/* <a onClick={this.setRedirect.bind(this, dataCountries[countryId].id, 'group')} href={"#L" + sportId + "89" + countryId} data-toggle="collapse" aria-expanded="false" className="dropdown-toggle">
                               
                                <i className={"ficon-inline f-" + countryId} />
                                {dataCountries[countryId].name}
                            </a> */}
                            <ul className="collapse list-unstyled" id={"L" + sportId + "89" + countryId}>
                                {leagues}
                            </ul>
                        </li>
                    })
                } else {
                    return null;
                }

                return <li key={sportId} className="">
                    <a href={"#L" + sportId} data-toggle="collapse" aria-expanded={sportId === '1' ? "true" : "false"} className={sportId === '1' ? "dropdown-toggle" : "d-none"}>
                        <i className={data[sportId].className}></i> {this.props.language(data[sportId].name).text}
                    </a>
                    <ul className={sportId === '1' ? "list-unstyled collapse show" : "collapse list-unstyled d-none"} id={"L" + sportId}>
                        {countries}
                    </ul>
                </li>

            })
        } else {
            sports = <div className="lds-ripple"><div></div><div></div></div>
        }

        data = this.state.fav;
        let fav = Object.keys(data);
        if (fav.length > 0) {
            fav = fav.map(i => {
                return <li key={i}>
                    {/* <a onClick={this.setRedirect.bind(this, data[i].id, 'league')} className="text-truncate" > <i className="fas fa-angle-double-right"></i> {data[i].fullname}</a> */}
                    <Link to={"/league/" + i} className="text-truncate"><i className="fas fa-star"></i> {data[i].fullname}</Link>
                </li>
            });

        }
        // console.log('/' + this.state.type + '/' + this.state.id, this.props.location.pathname);

        return (
            <nav id="sidebar" className="px-2">
                {/* {this.state.route!== this.props.location.pathname ? this.renderRedirect() : ""} */}

                {this.props.auto==false && <div className="sidebar-header d-none d-md-flex justify-content-center">
                    <Link to="/" style={{ fontSize: 30 }} className="text-center">
                        <img className="img-logo" alt="" src={this.props.logo} width="150" />
                        {NAME}<span style={{ color: "white" }}>{LASTNAME}</span>
                    </Link>

                </div>}
                <div className="d-flex justify-content-around pt-3">
                    <div onClick={this.props.changeLanguage} className="btn btn-dark btn-sm d-inline-block"><i className={this.props.language().language === 'es' ? "ficon-inline f-176" : (this.props.language().language === 'en' ? "ficon-inline f-200" : "ficon-inline f-0")}></i>{this.props.language().language}</div>
                    <div onClick={this.props.changeFormat} className="btn btn-dark btn-sm d-inline-block">{this.props.format}</div>
                    {/* <button className="btn btn-sm btn-outline-warning" onClick={p=>{ window.print()}}>Printer</button> */}
                    {/* <button type="button" onClick={this.props.changeLanguage} className="btn btn-dark btn-sm d-inline-block d-lg-none "><i className={this.props.language().language === 'es' ? "ficon-inline f-176" : (this.props.language().language === 'en' ? "ficon-inline f-200" : "ficon-inline f-0")}></i>{this.props.language().language}</button> */}
                </div>

                <ul className="list-unstyled components">
                    <p className="listHeader">{this.props.language().fav}</p>
                    {fav}
                </ul>
                <ul className="list-unstyled components">
                    <p className="listHeader">{this.props.language().moreLeagues}</p>
                    {sports}
                </ul>

            </nav>
        )
    }
}


export default Sidepanel;


// WEBPACK FOOTER //
// ./src/components/Sidepanel.js